<template lang="pug">
  div#company-name-search
    template(v-if="isCompanyListLoading === true")
      loading(:height="200")
    template(v-else)
      b-list-group(v-for="company in company_list")
        b-list-group-item.p-2(@click="setCompanyName(company)")
          span.pr-3.font-weight-bold {{company.name}}
          br(v-if="company.office !== ''")
          span.small {{company.office}}
          br
          span.small {{company.address}}

</template>

<script>
import Loading from '@/components/Loading';
export default {
  name: "CompanyNameSearch",
  components: {
    Loading
  },
  props: {
    company_list: { type: Array, required: false },
    isCompanyListLoading: { type:Boolean, required: false }
  },
  methods: {
    setCompanyName (company) {
      this.$emit('select', company)
    },
  }
}
</script>

<style scoped>
#company-name-search {
  height: 260px;
  overflow:hidden;
  overflow-y:scroll;
}
</style>